import global from "../global.js";

const d3 = global.d3;

const log = global.log.getLogger("f_mtac.global.view.D3Driver");
log.setLevel(log.levels.WARN);

const cc = {
    box: {
        translate: {
            x: {
                min: () => -16384,
                max: () => +16384
            },
            y: {
                min: () => -16384,
                max: () => +16384
            }
        }
    }
};

/**
 * The class D3Driver is responsible for
 *  - catching D3 events and processing related actions
 *  - applying view actions (zoom, translation, ...)
 * @param view_
 * @constructor
 */
const D3Driver = function (view_) {
    log.debug("D3Driver", {view_});
    var conf = global.configuration.module_configuration("view", cc);
    var view = view_;
    var state = {};

    const zoom = d3.zoom();
    zoom.scaleExtent([conf.get("box.scale.min"), conf.get("box.scale.max")]);
    zoom.translateExtent([
        [conf.get("box.translate.x.min"), conf.get("box.translate.y.min")],
        [conf.get("box.translate.x.max"), conf.get("box.translate.y.max")]
    ]);
    /**
     * Catch the D3 zoom event and forward it to the view
     */
    zoom.on("zoom", () => {
        
        state = {
            x: d3.event.transform.x,
            y: d3.event.transform.y,
            k: d3.event.transform.k
        };
        //log.debug("D3 on zoom", state);
        view.on_d3_zoom(state);
    });

    var zoom_active_start = () => {
        log.debug("zoom_active_start");
        view.zoom_active = true;
    };
    var zoom_active_end = () => {
        log.debug("zoom_active_end");
        view.center_to_locked_position();
        view.zoom_active = false;
    };

    this.zoom_active_handlers_enable = () => {
        log.debug("zoom_active_handlers_enable");
        zoom.on("start.active", zoom_active_start);
        zoom.on("end.active", zoom_active_end);
    };
    this.zoom_active_handlers_disable = () => {
        log.debug("zoom_active_handlers_disable");
        zoom.on("start.active", null);
        zoom.on("end.active", null);
    };

    /**
     * Center the view to a given object
     * @param w width of the object
     * @param h height of the object
     * @param x left coordinate of te object
     * @param y top coordinate of the object
     * @param k scale ratio
    */
    this.center_to_object = function({width: w, height: h, x, y}, k) {
        log.debug("center_to_object", {w, h, x, y, k});
        //var {width: W, height: H} = this; // view width and height
        let W = global.view.width;
        let H = global.view.height;
        // moving x,y to object center
        x += w / 2;
        y += h / 2;

        // computing transform from view center
        x = W / 2 - x * k;
        y = H / 2 - y * k;

        this.transform_to({x, y, k});
    };

    /**
     * Apply a given transformation to D3
     * @param x, the horizontal translation
     * @param y, the vertical translation
     * @param k, the zoom ratio
     */
    this.transform_to = ({x, y, k}) => {
        if (x === undefined || y === undefined || k === undefined){
            return;
        }
        //log.debug("transform_to", {x, y, k});
        this.zoom_active_handlers_disable();
        zoom.transform(d3.select(view.container), d3.zoomIdentity.translate(x, y).scale(k));
        this.zoom_active_handlers_enable();
    };

    /**
     * Apply a given translation to D3
     * @param x, the horizontal translation
     * @param y, the vertical translation
     */
    this.translate = (x, y) => {
        log.debug("translate", {x, y});
        zoom.translateTo(d3.select(view.container), x, y);
    };

    /**
     * Apply a zoom to D3 : called when the zoom button is pressed
     * @param dk float: zoom rate of the map
     */
    this.zoom = (dk) => {
        log.debug("zoom", {dk});
        zoom.scaleBy(d3.select(view.container), dk);
    };

    this.enable_zoom = () => {
        log.debug("enable_zoom");
        d3.select(view.container).call(zoom).on("dblclick.zoom", null);
    };

    this.disable_zoom = () => {
        log.debug("disable_zoom");
        d3.select(view.container).on(".zoom", null);
    };
};

export default D3Driver;
